import React from "react";
import InputReadOnly from '../../../InputReadOnly';
const YesNoQuestionInput = (props) => {
    return React.createElement(InputReadOnly, { hasHtmlLabel: true, label: `${props.title ? props.title : ""}`, content: `${props.currentValue == true ? props.t("common.yes") : (props.currentValue == false ? props.t("common.no") : props.t("common.dontknow"))}` });
};
export default YesNoQuestionInput;
